const shouldResetBedroomQuantity = (formValues, prevValues) => {
  return formValues.dwelling !== prevValues.dwelling
}

export {
  shouldResetBedroomQuantity
}